import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext.js';

/**
 * Admin/Manager-only routes (the survey editor + automation).
 *
 * Manager is "near-Admin" — full survey read/write, just not staff management
 * (staff-RBAC, 2026-08-10). Sits inside RequireAuth, so `user` is already
 * resolved — a User who types the URL goes to the dashboard rather than an
 * error. The backend enforces the same rule; this only keeps the UI honest.
 */
export function RequireManager({ children }: { children: ReactNode }) {
  const { user } = useAuth();

  if (user !== null && user.role !== 'ADMIN' && user.role !== 'MANAGER') {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
